import { render } from "./Whatsapp.vue?vue&type=template&id=37628e8a"
const script = {}
script.render = render

export default script